import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-vertical-button-text" }
const _hoisted_2 = { class: "tw-aside-tools-inner" }
const _hoisted_3 = {
  class: "bg-white d-flex justify-content-between align-items-center mt-4 ml-4",
  style: {"height":"50px"}
}
const _hoisted_4 = { class: "text-primary cursor-pointer" }
const _hoisted_5 = {
  class: "bold text-primary cursor-pointer font-semi-bold",
  style: {"text-decoration":"underline"}
}
const _hoisted_6 = { class: "text-grey mt-4 d-inline-flex align-items-center" }
const _hoisted_7 = { class: "bold text-grey font-semi-bold" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = {
  class: "row flex-start mb-3 justify-content-between flex-nowrap",
  style: {"gap":"10px"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = { class: "card bg-white" }
const _hoisted_13 = { class: "card-footer d-flex justify-content-end" }
const _hoisted_14 = { class: "card bg-white" }
const _hoisted_15 = { class: "card-footer d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_SummaryHistory = _resolveComponent("SummaryHistory")!
  const _component_SummaryTiers = _resolveComponent("SummaryTiers")!
  const _component_SummaryAsset = _resolveComponent("SummaryAsset")!
  const _component_SummaryFinancement = _resolveComponent("SummaryFinancement")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSummaryPanel && _ctx.openSummaryPanel(...args))),
      class: "btn btn-success summary-trigger-btn"
    }, [
      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "svg-icon" }, [
        _createElementVNode("svg", {
          width: "25",
          height: "28",
          viewBox: "0 0 25 28",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M7.40094 3.4401V2.10677C7.40033 1.76658 7.52977 1.43903 7.76277 1.19116C7.99577 0.943285 8.3147 0.793848 8.65427 0.773438H16.0009C16.3381 0.797099 16.6538 0.947953 16.884 1.19548C17.1142 1.44301 17.2418 1.76874 17.2409 2.10677V3.4401C17.2418 3.77813 17.1142 4.10386 16.884 4.35139C16.6538 4.59892 16.3381 4.74978 16.0009 4.77344H8.65427C8.3147 4.75303 7.99577 4.60359 7.76277 4.35572C7.52977 4.10785 7.40033 3.78029 7.40094 3.4401ZM24.0009 10.3068V19.9334C24.0168 20.8755 23.847 21.8114 23.5011 22.6878C23.1552 23.5642 22.6401 24.3639 21.9851 25.0412C21.3301 25.7185 20.5481 26.2601 19.6837 26.6351C18.8194 27.0101 17.8897 27.2111 16.9476 27.2268H7.08094C5.18074 27.2022 3.36795 26.4246 2.04054 25.0646C0.713134 23.7047 -0.0204132 21.8737 0.000939745 19.9734V10.3468C-0.0270515 8.61371 0.571086 6.92871 1.68552 5.60118C2.79996 4.27366 4.35589 3.39271 6.06761 3.1201V3.4401C6.06729 4.1337 6.33724 4.80013 6.82016 5.29799C7.30309 5.79585 7.96099 6.08596 8.65427 6.10677H16.0009C16.6919 6.08257 17.3464 5.79097 17.8265 5.29348C18.3066 4.79598 18.5747 4.13147 18.5743 3.4401V3.21344C20.1405 3.62092 21.5255 4.54049 22.5088 5.82584C23.4921 7.1112 24.0174 8.68849 24.0009 10.3068ZM7.80094 15.4134L10.9743 19.3334C11.0666 19.4457 11.1826 19.5362 11.314 19.5985C11.4454 19.6607 11.5889 19.6931 11.7343 19.6934C11.8856 19.6924 12.0345 19.6557 12.1689 19.5861C12.3033 19.5166 12.4193 19.4163 12.5076 19.2934L16.8543 13.4401C16.9828 13.2317 17.0357 12.9855 17.0041 12.7427C16.9726 12.4999 16.8585 12.2754 16.6809 12.1068C16.4748 11.9647 16.2224 11.9064 15.9748 11.9435C15.7272 11.9806 15.503 12.1105 15.3476 12.3068L11.7476 17.1468L9.33427 14.1601C9.17326 13.9701 8.94633 13.8479 8.69903 13.8183C8.45172 13.7886 8.20234 13.8536 8.00094 14.0001C7.79628 14.1676 7.66209 14.4059 7.62504 14.6677C7.58799 14.9296 7.65078 15.1958 7.80094 15.4134Z",
            fill: "currentColor"
          })
        ])
      ], -1)),
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("demand.financialSituation.summaryOfTheOffer")), 1)
    ], 512), [
      [_vShow, !_ctx.isTaskModuleOrder && !_ctx.summaryPanel && _ctx.offer?.resourceUid]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card w-60",
        style: _normalizeStyle(_ctx.summaryPanel ? 'right:0px' : 'right:-30vw')
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "card-title mb-0",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNewTab && _ctx.openNewTab(...args)))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t("summaryPanel.banner")) + " ", 1),
              _createElementVNode("span", _hoisted_5, "Nº " + _toDisplayString(_ctx.offer?.reference), 1)
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t("demand.filtreMenu.externeReference")) + " ", 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.offer?.businessData?.proposalReference || '-'), 1),
              _withDirectives(_createVNode(_component_q_btn, {
                dense: "",
                flat: "",
                round: "",
                size: "sm",
                color: "grey",
                icon: "delete",
                class: "ml-1",
                onClick: _withModifiers(_ctx.openDeleteOfferDialog, ["stop"])
              }, null, 8, ["onClick"]), [
                [_vShow, _ctx.isMo() && _ctx.isAdmin]
              ])
            ])
          ]),
          _createElementVNode("span", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openSummaryPanel && _ctx.openSummaryPanel(...args))),
            class: "cursor-pointer"
          }, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("svg", {
              width: "30",
              height: "30",
              viewBox: "0 0 30 30",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("rect", {
                opacity: "0.5",
                x: "6",
                y: "17.3137",
                width: "16",
                height: "2",
                rx: "1",
                transform: "rotate(-45 6 17.3137)",
                fill: "currentColor"
              }),
              _createElementVNode("rect", {
                x: "7.41422",
                y: "6",
                width: "16",
                height: "2",
                rx: "1",
                transform: "rotate(45 7.41422 6)",
                fill: "currentColor"
              })
            ], -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_btn, {
              label: _ctx.$t('demand.tabs.tiers'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSummary('TIERS'))),
              class: _normalizeClass(["btn btn-sm w-100", _ctx.summarySelected === 'TIERS' ? 'btn-primary' : 'btn-outline-primary'])
            }, null, 8, ["label", "class"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('demand.tabs.asset'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSummary('ASSET'))),
              class: _normalizeClass(["btn btn-sm w-100", _ctx.summarySelected === 'ASSET' ? 'btn-primary' : 'btn-outline-primary'])
            }, null, 8, ["label", "class"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('demand.tabs.financing'),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSummary('FINANCEMENT'))),
              class: _normalizeClass(["btn btn-sm w-100", _ctx.summarySelected === 'FINANCEMENT' ? 'btn-primary' : 'btn-outline-primary'
              ])
            }, null, 8, ["label", "class"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('demand.tabs.history'),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSummary('HISTORIQUE'))),
              class: _normalizeClass(["btn btn-sm w-100", _ctx.summarySelected === 'HISTORIQUE' ? 'btn-primary' : 'btn-outline-primary'])
            }, null, 8, ["label", "class"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.summarySelected === 'HISTORIQUE' )
                ? (_openBlock(), _createBlock(_component_SummaryHistory, {
                    key: 0,
                    parties: _ctx.parties,
                    asset: _ctx.asset,
                    historiesStep: _ctx.historiesStep,
                    entityState: _ctx.$store.state.summaryPanelModule.offer
                  }, null, 8, ["parties", "asset", "historiesStep", "entityState"]))
                : _createCommentVNode("", true),
              (_ctx.tabSelected === 'TIERS')
                ? (_openBlock(), _createBlock(_component_SummaryTiers, {
                    key: 1,
                    arrParties: _ctx.parties
                  }, null, 8, ["arrParties"]))
                : (_ctx.tabSelected === 'ASSET')
                  ? (_openBlock(), _createBlock(_component_SummaryAsset, {
                      key: 2,
                      asset: _ctx.asset
                    }, null, 8, ["asset"]))
                  : (_ctx.tabSelected === 'FINANCEMENT')
                    ? (_openBlock(), _createBlock(_component_SummaryFinancement, { key: 3 }))
                    : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 4)
    ], 512), [
      [_vShow, !_ctx.isTaskModuleOrder && _ctx.summaryPanel && _ctx.offer?.resourceUid]
    ]),
    _createVNode(_component_q_dialog, {
      class: "theme-1",
      modelValue: _ctx.showDeleteOfferDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showDeleteOfferDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-body" }, [
            _createElementVNode("span", { class: "font-size-14 d-block" }, "Voulez-vous supprimer l'offre ?")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_q_btn, {
              class: "btn btn-action mr-3",
              label: "Non",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDeleteOfferDialog = false))
            }),
            _createVNode(_component_q_btn, {
              class: "btn btn-danger",
              label: "Oui",
              onClick: _ctx.confirmDeleteOffer
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      class: "theme-1",
      modelValue: _ctx.showDeleteOfferSureDialog,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDeleteOfferSureDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-body" }, [
            _createElementVNode("span", { class: "font-size-14 d-block" }, "Êtes-vous sûr ?")
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_q_btn, {
              class: "btn btn-action mr-3",
              label: "Non",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteOfferSureDialog = false))
            }),
            _createVNode(_component_q_btn, {
              class: "btn btn-danger",
              label: "Oui",
              onClick: _ctx.deleteOffer
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}